export interface ISettings {
    isNextJS: () => boolean;
    isLazySupported: () => boolean;
}

const ENV = {
    NEXT_PUBLIC_IS_NEXTJS: Boolean(process.env['NEXT_PUBLIC_IS_NEXTJS']),
};

function settings(): ISettings {
    return {
        isNextJS: () => ENV.NEXT_PUBLIC_IS_NEXTJS,
        isLazySupported: () => !ENV.NEXT_PUBLIC_IS_NEXTJS,
    };
}

export default settings();
